import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IConsumableDetails } from "@Models/IConsumableDetails";
import { IEntity } from "@Models/IEntity";
import { IConsumablePayload } from "@Models/IConsumablePayload";
import {IConsumableDrawDownDetails} from "@Models/IConsumableDrawDownDetails";

export default class ConsumablesService extends ServiceBase {

    public async getAll(): Promise<Result<IConsumablePayload>> {
        return await this.requestJson<IConsumablePayload>({
            url: `/api/Consumable/GetAll`,
            method: "GET"
        });
    }

    public async create(model: IConsumableDetails) : Promise<Result<IEntity>> {
        return await this.requestJson<IEntity>({
            url: `/api/Consumable/Create`,
            method: "POST",
            data: model
        });
    }

    public async updateImage(id: string, model: FormData) : Promise<Result<string>> {
        return await this.requestJson({
            url: `/api/Consumable/UpdateImage/${id}`,
            method: "PATCH",
            data: model
        });
    }

    public async update(model: IConsumableDetails) : Promise<Result<boolean>> {
        return await this.requestJson({
            url: `/api/Consumable/Update/${model.consumableId}`,
            method: "PATCH",
            data: model
        });
    }

    public async delete(consumableId: string) : Promise<Result<boolean>> {
        return await this.requestJson({
            url: `/api/Consumable/Delete/${consumableId}`,
            method: "DELETE"
        });
    }

    public async createOrder(creditId: string, model: IConsumableDrawDownDetails) : Promise<Result<IEntity>> {
        return await this.requestJson<IEntity>({
            url: `/api/Consumable/CreateOrder/${creditId}`,
            method: "POST",
            data: model
        });
    }
}
